<div class="driver-utilisation-graph">
  <div class="driver-utilisation-graph__header">
    <h4 class="driver-utilisation-graph__title">{{ 'driverDashboard.graphs.driverUtilisation' | transloco }}</h4>
    <app-date-filter
      [filter]="utilizationDateFilter"
      [isButtonIntervalSelector]="false"
      [disabledIntervals]="disabledIntervals"
      [disableCustomDateSelector]="true"
      [defaultInterval]="defaultInterval"
      (filterChanged)="onDateFilterChange($event)">
    </app-date-filter>
  </div>

  <div class="driver-utilisation-graph__body">
    @if (isLoading) {
      <div class="driver-utilisation-graph__spinner spinner-border"></div>
    } @else if (hasError) {
      <app-graph-error-state></app-graph-error-state>
    } @else if (!hasData) {
      <div class="driver-utilisation-graph__no-data">
        <app-empty-state></app-empty-state>
      </div>
    } @else {
      @defer (on timer(100ms)) {
        <div class="driver-utilisation-graph__chart">
          <app-vertical-bar-chart
            [data]="chartData"
            [margin]="{ top: 20, right: 20, bottom: 40, left: 40 }"
            [barWidth]="22"
            [minHeight]="180"
            [yMax]="100"
            [yTickInterval]="25"
            [showDataLabels]="true"
            [dataLabelFormatter]="formatPercent"
            [yAxisFormatter]="formatPercent">
          </app-vertical-bar-chart>
        </div>
      }
    }
  </div>
</div>